import { render, staticRenderFns } from "./DailyNews.vue?vue&type=template&id=7a4cfc5b&scoped=true"
import script from "./DailyNews.vue?vue&type=script&lang=js"
export * from "./DailyNews.vue?vue&type=script&lang=js"
import style0 from "./DailyNews.vue?vue&type=style&index=0&id=7a4cfc5b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4cfc5b",
  null
  
)

export default component.exports